// extracted by mini-css-extract-plugin
export default {"tabsScroll":"TabComponent_tabsScroll__rvfJZ"};